// Bundle reservations by check-out time
export const bundleByCheckOutTime = (data) => {
    const bundleDict = {};

    for (const reservation of data) {
        const key = `${reservation.userId}_${reservation.checkOutTime}`;
        
        if (!bundleDict[key]) {
            bundleDict[key] = {
                studentId: reservation.studentId,
                userId: reservation.userId,
                firstName: reservation.firstName,
                lastName: reservation.lastName,
                checkOutDate: reservation.checkOutDate,
                checkOutTime: reservation.checkOutTime,
                role: reservation.role,
                reservations: []
            };
        }

        bundleDict[key].reservations.push(reservation);
    }

    return Object.values(bundleDict);
};

// Bundle reservations by check-in time
export const bundleByCheckInTime = (data) => {
    const bundleDict = {};

    for (const reservation of data) {
        const key = `${reservation.userId}_${reservation.checkInTime}`;

        if (!bundleDict[key]) {
            bundleDict[key] = {
                studentId: reservation.studentId,
                userId: reservation.userId,
                firstName: reservation.firstName,
                lastName: reservation.lastName,
                checkInDate: reservation.checkInDate,
                checkInTime: reservation.checkInTime,
                role: reservation.role,
                reservations: []
            };
        }

        bundleDict[key].reservations.push(reservation);
    }

    return Object.values(bundleDict);
};

export const BundleReservations = (checkOutData, checkInData) => {
    return {
        checkOutData: bundleByCheckOutTime(checkOutData),
        checkInData: bundleByCheckInTime(checkInData)
    };
};
